"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InverseLiquidity = void 0;
const sdks_perp_1 = require("@synfutures/sdks-perp");
const dataSource_1 = require("../dataSource");
const utils_1 = require("../../utils");
class InverseLiquidity extends dataSource_1.Liquidity {
    async getLiquidityData(instrumentAddr, expiry, spacing = sdks_perp_1.RANGE_SPACING, blockNumber) {
        const isInverse = await this.dataSource.ctx.perp.configuration.isInverse(instrumentAddr);
        const results = await super.getLiquidityData(instrumentAddr, expiry, spacing, blockNumber);
        return isInverse
            ? results.map((l) => {
                return {
                    ...l,
                    price: (0, utils_1.reversePrice)(l.price),
                };
            })
            : results;
    }
}
exports.InverseLiquidity = InverseLiquidity;
